// extracted by mini-css-extract-plugin
export default {"shippingModalLink":"ModalLink-shippingModalLink","label":"ModalLink-label"};